<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii">HISTORY</a></h1><a id="page_iii">
<p class="line">
</p><p class="subtitle"><em class="italic">An Absorbing Look at How American History Has<br/>Changed in the Telling over the Last 200 Years</em></p>
<p class="line">
</p><h1 class="title1">IN THE MAKING</h1>
<p class="logo"><img src="images/logoa.jpg"/></p>
<p class="author">Kyle Ward</p>
<p class="pub-image"><img src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?100c1963